var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{staticClass:"text-center"},[_c('h3',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('page_not_found')))]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'welcome' }}},[_vm._v("\n      "+_vm._s(_vm.$t('go_home'))+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0995ba4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/errors/404.vue
// module id = null
// module chunks = 